import { render, staticRenderFns } from "./ArticlesEditor.vue?vue&type=template&id=0a8978ff&scoped=true&"
import script from "./ArticlesEditor.vue?vue&type=script&lang=js&"
export * from "./ArticlesEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8978ff",
  null
  
)

export default component.exports